import { Component, EventEmitter, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { IExam, IExamCategory } from 'src/app/interface/dto';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { ExamOperationService } from '../exam-operation.service';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';

@Component({
  selector: 'app-exam-category',
  templateUrl: './exam-category.component.html',
  styleUrls: ['./exam-category.component.scss']
})
export class ExamCategoryComponent implements OnInit, OnDestroy {
  exam: IExam = examDefault;

  categories: IExamCategory[] = null;
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'ExaminationID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Number Of Questions',
      fieldName: 'numberOfQuestions',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Category',
      fieldName: 'category',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Instruction',
      fieldName: 'instruction',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }
  ];
  selectedCategory: IExamCategory = {
    examinationID: 0,
    numberOfQuestions: 0,
    category: '',
    instruction: '',
    maximumNumberOfEssayAnswers: 0,
    maximumNumberOfSAQAnswers: 0,
    categorySource: '',
    questionBankPoolSize: 0,
    id: 0
  }
  constructor(private examService: ExamService, private router: Router, private snackBar: SnackbarService,
    private examOps: ExamOperationService, private evnt: EventService) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];

      if (this.exam.examinationTypeenum === "Essay") {
        this.columns.splice(2, 0, {
          displayName: "Maximun Number Of Answers",
          fieldName: "maximumNumberOfEssayAnswers",
          fieldDataType: FieldDataType.number,
          searchable: true,
          orderable: true,

        });
      }

      if (this.exam.examinationTypeenum === "SAQ") {
        this.columns.splice(2, 0, {
          displayName: "Maximun Number Of Answers",
          fieldName: "maximumNumberOfSAQAnswers",
          fieldDataType: FieldDataType.number,
          searchable: true,
          orderable: true,

        });
      }

      if (this.exam.useQuestionBank) {
        this.columns.splice(2, 0, {
          displayName: "Category Source",
          fieldName: "categorySource",
          fieldDataType: FieldDataType.text,
          searchable: true,
          orderable: true,
        });
      }

      GridUtil.setClearGridSelection();

      await this.refreshData(this.data.tableParams);

      this.evnt.adCategoryMessageEvent.subscribe((message: any) => {
        this.refreshData(this.data.tableParams);
      })
    }
  }

  ngOnDestroy(): void {
    this.evnt.adCategoryMessageEvent.unsubscribe();
  }
  addCategory(origin) {
    sessionStorage.setItem("selectedCategory", null);
    this.examOps.openModal(origin, AddCategoryComponent)
  }

  editCategory(origin) {
    sessionStorage.setItem("selectedCategory", JSON.stringify(this.selectedCategory));
    this.examOps.openModal(origin, AddCategoryComponent);
  }
  async deleteCategory() {
    await this.examService.deleteExamCategory(this.selectedCategory).then(async (response: any) => {
      this.snackBar.success('Category deleted');
      await this.refreshData(this.data.tableParams);
    });
  }

  rowSeleceted(categoryRowId: any[]) {
    this.selectedCategory = this.data.tableRows[categoryRowId[0]] as IExamCategory;

    let storedId = GridUtil.getSelectedDataID('examinationCategoryGrid');
    const storedIds = Array.isArray(storedId) ? storedId : storedId ? [storedId] : [];

    const selectedDataRowsId = storedIds.length > 0 ? storedIds : [this.selectedCategory.id];
    GridUtil.setRowCliclk('examinationCategoryGrid', categoryRowId, selectedDataRowsId);
    sessionStorage.setItem("selectedCategory", JSON.stringify(this.selectedCategory));
  }

  async refreshData(tableParams) {
    tableParams.ExaminationID = this.exam.id;
    const res = await this.examService.getExamCategoryTable(tableParams) as any[];
    this.updateGridParams(res);
  }
  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }
}
